import { createAsyncThunk } from '@reduxjs/toolkit';
import NotesService from '../../services/notes.service';
import axios from 'axios';
import { getBaseurl } from '../../services/varification';
import { getAccessToken } from '../../common-utils/util';

export const createNotes = createAsyncThunk(
  'notes/create',
  async ({ keyNumbers, data }) => {
     //const raes = await NotesService.create(keyNumbers, data);
    const res = await axios.post(
      getBaseurl() + '/http-request-proxy', 
      {
        url: `createNote`,
        method: 'POST',
        body: data,
        params: {
          keyNumbers: keyNumbers,
        },
        headers: {
            'sessionid': getAccessToken(),
            account: window.sessionStorage.getItem('customerId') ? window.sessionStorage.getItem('customerId') : 'all' ,
            useremail: window.sessionStorage.getItem('oktaLogin')
          }
      }
    );
    return res.data;
  }
);

export const retrieveAllNotes = createAsyncThunk(
  'notes/retrieve',
  async ({ leadSource, key, payload }) => {
   // console.log('====', key, payload);
    // const res = await NotesService.getAllNotes(leadSource, key, payload);
    const res = await axios.post(
      getBaseurl() + '/http-request-proxy',
      {
        url: `getAllNotes`,
        method: 'POST',
        body: payload,
        params: {
          keyID: key,
          leadSource: leadSource,
        },
        headers: {
            'sessionid': getAccessToken(),
            account: window.sessionStorage.getItem('customerId') ? window.sessionStorage.getItem('customerId') : 'all' ,
            useremail: window.sessionStorage.getItem('oktaLogin')
          }
      })
    return res.data.response.items;
  }
);

export const getNotesDetails = createAsyncThunk(
  'notes/details',
  async ({ noteId }) => {
    //console.log("noteId", noteId)
    const res = await NotesService.get(noteId);
    return res.data.response.items;
  }
);

export const getNotesDetailsById = createAsyncThunk(
  'notes/detailsById',
  async ({ keyNumbers,leadSource, noteId }) => {
    //console.log("noteId", noteId)
    //const res = await NotesService.getNoteById(keyNumbers, leadSource, noteId);
    const res = await axios.post(
      getBaseurl() + '/http-request-proxy',
      {
        url: `getNoteDetailsById`,
        method: 'GET',
        params: {
          keyNumbers: keyNumbers,
          leadSource: leadSource,
          noteId: noteId,
        },
        headers: {
            'sessionid': getAccessToken(),
            account: window.sessionStorage.getItem('customerId') ? window.sessionStorage.getItem('customerId') : 'all' ,
            useremail: window.sessionStorage.getItem('oktaLogin')
          }
      }
    );  
    return res.data.response.items;
  }
);

export const updateNote = createAsyncThunk(
  'notes/update',
  async ({ keyNumbers, noteId, data }) => {
    // console.log("body",keyNumbers,noteId, data)

    //const res = await NotesService.update(keyNumbers, noteId, data);
    const res = await axios.post(
      getBaseurl() + '/http-request-proxy',
      {
        url: `getNoteDetailsById`,
        method: 'GET',
        body: data,
        params: {
          keyNumbers: keyNumbers,
          noteId: noteId,
        },
        headers: {
            'sessionid': getAccessToken(),
            account: window.sessionStorage.getItem('customerId') ? window.sessionStorage.getItem('customerId') : 'all' ,
            useremail: window.sessionStorage.getItem('oktaLogin')
          }
      }
    );  
    return res.data;
  }
);
